// react core
import React from 'react';
import  { Navigate } from 'react-router-dom'

// conf
import conf from 'conf/ajax';

export default function QARoot(props)
{
    return (
        <Navigate to={conf.route.main}  />
    )
}